import { Button, makeStyles } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import { CourseCommentInput } from './course-comment-input/CourseCommentInput';

const useStyles = makeStyles({
  button: {
    borderRadius: 8,
  },
});

export const CourseCommentQuestion = ({
  title,
  rows,
  placeHolder,
  answer,
  name,
  saveAnswer,
  saveLabel,
}) => {
  const [value, setValue] = useState('');
  const classes = useStyles();
  const prevValue = useRef();

  const isSaved = prevValue.current && answer === value;

  useEffect(() => {
    if (isSaved) {
      setValue('');
    }
  }, [isSaved]);

  const onChange = e => {
    prevValue.current = e.target.value;
    setValue(e.target.value);
  };

  return (
    <div>
      <CourseCommentInput
        title={title}
        rows={rows}
        placeHolder={placeHolder}
        onChange={onChange}
        value={value}
      />
      <Button
        className={classes.button}
        color="primary"
        variant="contained"
        size="medium"
        onClick={() => saveAnswer(name, value)}
        disabled={!value.length}
      >
        {saveLabel}
      </Button>
    </div>
  );
};
